<template>
  <div>
    <cheques-filtro ref="chequesFiltro"></cheques-filtro>

    <z-centralized-toolbar>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            depressed
            rounded
            v-on="on"
            color="primary"
            to="/cheques/controle/adicionar"
          >
            <v-icon left>add</v-icon>
            Novo Cheque
          </v-btn>
        </template>
        Novo Cheque
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            text
            rounded
            v-on="on"
            @click="$refs.chequesFiltro.abrir()"
          >
            <v-icon left>filter_list</v-icon>
            Filtrar
          </v-btn>
        </template>
        Filtro
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            :loading="$store.state.loading"
            @click="refresh"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </template>
        Atualizar
      </v-tooltip>

      <z-text-field-search 
        v-model="search" 
        select 
        class="ml-5" 
        @keydown.enter="$refs.chequesFiltro.aplicar()" 
        @click:clear="limparBusca"
      ></z-text-field-search>
    </z-centralized-toolbar>

    <z-container>
      <h3 class="text-body-1 mb-3">Cheques</h3>

      <v-card>
        <v-card-text v-if="filtroChips.length > 0">
          <div>
            Fitlro: 
            <v-chip
              v-for="(chip, index) in filtroChips"
              class="mr-2"
              close
              :key="index"
              @click:close="removerFiltro(chip)"
            >
              {{ chip.descricao }}
            </v-chip>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-data-table
          :options.sync="options"
          :server-items-length="total_de_registros"
          :footer-props="$globals.FOOTER_PROPS"
          :headers="headers"
          :items="cheques"
          item-key="id"
          :loading="false"
        >
          <template v-slot:item="{ item: cheque }">
            <tr class="apontador" @click="alterarStatus(cheque)">
              <td>{{ cheque.numero }}</td>
              <td>{{ cheque.banco }}</td>
              <td>{{ cheque.agencia }}</td>
              <td>{{ cheque.conta }}</td>
              <td>{{ cheque.vencimento | dataBR }}</td>
              <td>{{ cheque.created_at | dataBR }}</td>
              <td>
                {{ cheque.cliente ? cheque.cliente.id : null }} -
                {{ cheque.cliente ? cheque.cliente.razao : null }}
              </td>
              <td class="text-right">
                <b>{{ cheque.valor | valorBR }}</b>
              </td>
              <td>
                <v-chip
                  small
                  label
                  text-color="white"
                  :color="corChip(cheque.status)"
                  >{{ cheque.status }}</v-chip
                >
              </td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click.stop="alterarStatus(cheque)">
                      <v-icon>share</v-icon>
                    </v-btn>
                  </template>
                  Status Cheque
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click.stop="editar(cheque)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  Editar Cheque
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      @click.stop="perguntarExcluir(cheque)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  Excluir Cheque
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo
      ref="dialogoExcluir"
      titulo="Excluir cheque?"
      largura="500px"
      :dividers="true"
    >
      <div slot="texto">
        <v-row class="text--primary" no-gutter dense>
          <v-col cols="3">
            <div class="font-weight-black overline">Número</div>
            <div>{{ cheque.numero }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-black overline">Vencimento</div>
            <div>{{ cheque.vencimento | dataBR }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-black overline">Cadastro</div>
            <div>{{ cheque.created_at | dataBR }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-black overline">Valor</div>
            <div>{{ cheque.valor | valorBR }}</div>
          </v-col>
          <v-col cols="12">
            <div class="font-weight-black overline">Emitente</div>
            <div>{{ cheque.emitente }}</div>
          </v-col>
          <v-col cols="12">
            <div class="font-weight-black overline">Cliente Responsável</div>
            <div>
              {{ cheque.cliente ? cheque.cliente.id : null }} -
              {{ cheque.cliente ? cheque.cliente.razao : null }}
            </div>
          </v-col>
        </v-row>
      </div>

      <v-btn text @click="$refs.dialogoExcluir.fechar()" :disabled="excluindo"
        >Cancelar</v-btn
      >
      <v-btn
        color="primary darken-1"
        depressed
        :loading="excluindo"
        :disabled="excluindo"
        @click="confirmarExcluir"
        >Excluir</v-btn
      >
    </z-dialogo>

    <z-dialogo
      ref="dialogoStatusCheque"
      titulo="Situação do Cheque"
      :dividers="true"
      largura="600px"
    >
      <template v-slot:texto>
        <v-row class="text--primary" no-gutter dense>
          <v-col cols="3">
            <div class="font-weight-black">Código</div>
            <div>{{ cheque.id }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-black">Número</div>
            <div>{{ cheque.numero }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-black">Banco</div>
            <div>{{ cheque.banco }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-black">Agência</div>
            <div>{{ cheque.agencia }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-black">Conta</div>
            <div>{{ cheque.conta }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-black">Vencimento</div>
            <div>{{ cheque.vencimento | dataBR }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-black">Cadastro</div>
            <div>{{ cheque.created_at | dataBR }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-black">Valor</div>
            <div>{{ cheque.valor | valorBR }}</div>
          </v-col>
          <v-col cols="12">
            <div class="font-weight-black">Emitente</div>
            <div>{{ cheque.emitente }}</div>
          </v-col>
          <v-col cols="12">
            <div class="font-weight-black">Cliente Responsável</div>
            <div>
              {{ cheque.cliente ? cheque.cliente.id : null }} -
              {{ cheque.cliente ? cheque.cliente.razao : null }}
            </div>
          </v-col>
          <v-col cols="12">
            <div class="font-weight-black">Cadastrado Por</div>
            <div>{{ cheque.usuario ? cheque.usuario.name : null }}</div>
          </v-col>
        </v-row>

        <v-divider class="mt-3"></v-divider>

        <v-row class="mt-1">
          <v-col sm="5">
            <v-radio-group
              hide-details
              class="mt-0"
              v-model="cheque.status"
              column
              label="Situação"
            >
              <v-radio
                label="Em Caixa"
                value="Em Caixa"
                color="green"
              ></v-radio>
              <v-radio
                label="Compensado"
                value="Compensado"
                color="blue"
              ></v-radio>
              <v-radio
                label="Devolvido"
                value="Devolvido"
                color="red"
              ></v-radio>
              <v-radio
                label="Repassado"
                value="Repassado"
                color="orange"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col sm="7">
            <div v-if="cheque.status == 'Devolvido'">
              <v-text-field
                v-model="cheque.motivo_devolucao"
                label="Motivo"
                dense
                filled
              ></v-text-field>
              <z-date-picker-menu
                v-model="cheque.data_devolucao"
                label="Data Devolução"
                dense
                filled
              ></z-date-picker-menu>
            </div>

            <div v-if="cheque.status == 'Repassado'">
              <v-text-field
                v-model="cheque.destino_repasse"
                label="Destino"
                dense
                filled
              ></v-text-field>
              <z-date-picker-menu
                v-model="cheque.data_repasse"
                label="Data Repasse"
                dense
                filled
              ></z-date-picker-menu>
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-slot:actions_right>
        <v-btn
          text
          @click="$refs.dialogoStatusCheque.fechar()"
          :disabled="salvando"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="mudarStatusCheque"
          :loading="salvando"
          :disabled="salvando"
          >Mudar</v-btn
        >
      </template>
    </z-dialogo>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import ChequesFiltro from "./ChequesFiltro";

export default {
  name: "ChequesLista",
  components: {
    ChequesFiltro,
  },

  data() {
    return {
      // globals,
      headers: [
        { text: "Número", value: "numero", width: "100px" },
        { text: "Banco", value: "banco", width: "90px" },
        { text: "Agência", value: "agencia", width: "100px" },
        { text: "Conta", value: "conta", width: "100px" },
        { text: "Vencimento", value: "vencimento", width: "120px" },
        { text: "Cadastro", value: "created_at", width: "120px" },
        { text: "Responsável", value: "cliente_id" },
        { text: "Valor", value: "valor", align: "right", width: "150px" },
        { text: "Situação", value: "status", width: "130px" },
        {
          text: "Opções",
          value: "",
          width: "200px",
          align: "center",
          sortable: false,
        },
      ],
      // search: "",
      pagination: {},
      excluindo: false,
      salvando: false,
      cheque: {
        cliente: {
          id: "",
        },
        status: "",
        movito_devolucao: "",
        data_devolucao: "",
        destino_repasse: "",
        data_repasse: "",
      },
      // listagem: 'hoje',
      exibir_filtro: false,
      drawer_right: false,
    };
  },

  created() {
    this.setTitulo("Controle de Cheques");

    if (this.cheques.length == 0) {
      this.listar(this.listagem);
    }
  },

  mounted() {
    this.$store.dispatch("listas/clientes");
    this.$store.dispatch("listas/bancos");
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("cheques", [
      "listar",
      "excluir",
      "abrir",
      "atualizar",
      "atualizarStatusCheque",
    ]),

    async refresh() {
      try {
        await this.$refs.chequesFiltro.aplicar();
        // await this.listar(this.listagem);
      } catch (error) {
        this.$eventbus.erro(
          "Não foi possível obter a lista de pedidos.",
          error
        );
        this.LOADING_OFF();
      }
    },

    async editar(cheque) {
      await this.abrir(cheque.id);
      this.$router.push({ name: "ChequesEditar", params: { id: cheque.id } });
    },

    perguntarExcluir(cheque) {
      this.cheque = cheque;
      this.$refs.dialogoExcluir.abrir();
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.cheque.id);
        this.$eventbus.notificar("Cheque excluído com sucesso!");
      } catch (error) {
        this.$eventbus.erro("Não foi possível excluir esse cheque.", error);
      } finally {
        this.$refs.dialogoExcluir.fechar();
        this.excluindo = false;
      }
    },

    alterarStatus(cheque) {
      // this.limparCheque();
      this.cheque = this.clone(cheque);
      this.$refs.dialogoStatusCheque.abrir();
    },

    async mudarStatusCheque() {
      try {
        this.salvando = true;

        if (
          this.cheque.status == "Em Caixa" ||
          this.cheque.status == "Compensado"
        ) {
          this.cheque.data_devolucao = null;
          this.cheque.motivo_devolucao = null;
          this.cheque.data_repasse = null;
          this.cheque.destino_repasse = null;
        }

        if (this.cheque.status == "Repassado") {
          this.cheque.data_devolucao = null;
          this.cheque.motivo_devolucao = null;
        }
        if (this.cheque.status == "Devolvido") {
          this.cheque.data_repasse = null;
          this.cheque.destino_repasse = null;
        }

        await this.atualizar(this.cheque);
      } catch (error) {
        this.$eventbus.erro(
          "Não foi possível alterar o status do cheque.",
          error
        );
      } finally {
        this.$refs.dialogoStatusCheque.fechar();
        this.salvando = false;
      }
    },

    limparCheque() {
      this.cheque.status = "";
      this.cheque.motivo_devolucao = "";
      this.cheque.data_devolucao = "";
      this.cheque.destino_repasse = "";
      this.cheque.data_repasse = "";
    },

    corChip(situacao) {
      switch (situacao) {
        case "Em Caixa":
          return "green";
          break;

        case "Compensado":
          return "blue";
          break;

        case "Devolvido":
          return "red";
          break;

        case "Repassado":
          return "orange";
          break;

        default:
          break;
      }
    },

    async removerFiltro(chip) {
      this.$store.commit("cheques/REMOVER_FILTRO", chip);
      await this.$refs.chequesFiltro.aplicar();
    },

    async limparBusca() {
      this.search = "";
      await this.$refs.chequesFiltro.aplicar();
    },
  },

  computed: {
    ...mapState("cheques", [
      "cheques",
      "filtrando",
      "filtro",
      "filtroChips",
      "total_de_registros",
    ]),

    listagem: {
      get() {
        return this.$store.state.cheques.listagem;
      },
      set(valor) {
        this.$store.commit("cheques/SET_LISTAGEM", valor);
      },
    },

    search: {
      get() {
        return this.$store.state.cheques.search;
      },
      set(search) {
        this.$store.commit("cheques/SET_SEARCH", search);
      },
    },

    options: {
      get() {
        return this.$store.state.cheques.pagination;
      },
      set(options) {
        this.$store.commit("cheques/UPDATE_PAGINATION", options);
      },
    },
  },

  watch: {
    listagem() {
      this.refresh();
    },

    options: {
      handler() {
        this.$refs.chequesFiltro.aplicar();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
